/*****
    Author:	    CT Software Systems, LLC
    Last Modified: 251223
*/
'use strict';

import {
    formatAsShortDate
} from './ctssDateTime.js'; 
import {
    getDiv,
    getLabel,
    getSpan,
    getTableRows
} from './ctssHtml.js';
import {
    allSettled,
    clearMySNError

} from './ctssJQuery.js';
import { getMembersDataAsync } from './snMembers.js'; 
import {
    getMuteIconText,
    getMuteMsg,
    getUnMuteMsg,
    toggleBannedAsync,
    toggleMutedAsync,
    removeAsync
} from './snMembersManagement.js';
import {
    getMemberProfileQuestionsAsync,
    getMemberProfileResponsesAsync
} from './snMemberProfile.js';
import { setMenu } from './snSite.js';

/* private functions */

const getDirectoryRow = (params) => {
    const mute = getMuteIconText({ isMuted: params.data.memberStats.isMuted });
    return '<tr id="row' + params.data.id + '">' +
        '<td class="col-md-2">' + params.data.name + '</td>' +
        '<td class="col-md-4">' + params.data.email + '</td>' +
        '<td class="col-md-2">' + params.data.phone + '</td>' +
        '<td class="col-md-4"><button class="btn btn-default btn-sm mRight5 w85" ' +
        ' data-toggle="modal" data-target="#confirmDlg" data-caller="mute" data-key="' +
        params.data.id + '"><span class="fa ' + mute.icon + '"></span> ' +
        mute.text + '</button><button title="Block ' + params.data.name +
        ' from using My Sermon Notes..." class="btn btn-default btn-sm mRight5 w60" ' +
        ' data-toggle="modal" data-target="#confirmDlg" data-caller="ban" data-key="' +
        params.data.id + '"><span class="fa fa-ban"></span> Block</button>' +
        '<button title="Remove ' + params.data.name +
        ' from church directory..." class="btn btn-default btn-sm mRight5 w75" ' +
        ' data-toggle="modal" data-target="#confirmDlg" data-caller="remove" data-key="' +
        params.data.id + '"><span class="fa fa-trash"></span> Remove</button>' +
        '<button title="View more information on ' +
        params.data.name + '" class="btn btn-default btn-sm" ' +
        ' data-toggle="modal" data-target="#memberDlg" data-key="' +
        params.data.id + '"> More...</button ></td > ' +
        '</tr>';
}

const initConfirmDlg = () => {
    $('#confirmDlg').on('show.bs.modal', (e) => {
        const caller = e.relatedTarget.dataset.caller,
            key = e.relatedTarget.dataset.key,
            idx = members.findIndex(x => x.id === parseInt(key, 10)),
            member = members[idx],
            name = member.name;
        let confirmDlgPrompt;

        switch (caller) {
            case 'ban':
                confirmDlgPrompt = `When you block ${name}, they will be unable to access your church profile ` +
                    'on My Sermon Notes. They cannot rejoin your church profile until you unblock them. Proceed?';
                $('#confirmDlgLbl').text(`Block ${name}?`);
                $('#confirmDlgPrompt').text(confirmDlgPrompt);
                break;
            case 'mute':
                $('#confirmDlgLbl').text((member.memberStats.isMuted ? 'Unmute ' : 'Mute ') + name + '?');
                $('#confirmDlgPrompt').text(member.memberStats.isMuted
                    ? getUnMuteMsg({ name: name })
                    : getMuteMsg({ name: name }));
                break;
            case 'remove':
                confirmDlgPrompt = `When you remove ${name} from the church directory, they will ` +
                    `be unable to access your church profile on My Sermon Notes. ${name} can rejoin your ` +
                    'church profile at any time. If you would like to prevent this, use the Block feature. Proceed?';
                $('#confirmDlgLbl').text(`Remove ${name} from church directory?`);
                $('#confirmDlgPrompt').text(confirmDlgPrompt);
                break;
            default:
                alert('Unknown caller');
                return;
        }

        $('#btnConfirmed').off().on('click', async () => {
            switch (caller) {
                case 'ban':
                    await toggleBannedAsync({
                        mg: member.mg,
                        divErrMsg: 'divConfirmDlgErrMsg'
                    }).then(() => {
                            members.splice(idx, 1);
                            getTableRows({ arr: members, fnGetRow: getDirectoryRow, gridNm: 'gridDirectory' });
                            $('#confirmDlg').modal('hide');
                            $('#successDlgPrompt').text(`${name} has been blocked from your church directory...`);
                            $('#successDlg').modal('show');
                        });
                    break;
                case 'mute':
                    await toggleMutedAsync({
                        mg: member.mg,
                        isMuted: !member.memberStats.isMuted,
                        divErrMsg: 'divConfirmDlgErrMsg'
                    }).then(() => {
                        member.memberStats.isMuted = !member.memberStats.isMuted;
                        $('#row' + member.id).replaceWith(getDirectoryRow({ data: member }));
                        $('#confirmDlg').modal('hide');
                    });
                    break;
                case 'remove':
                    await removeAsync({
                        mg: member.mg,
                        divErrMsg: 'divConfirmDlgErrMsg'
                    }).then(() => {
                        members.splice(idx, 1);
                        getTableRows({ arr: members, fnGetRow: getDirectoryRow, gridNm: 'gridDirectory' });
                        $('#confirmDlg').modal('hide');
                        $('#successDlgPrompt').text(`${name} has been removed from your church directory...`);
                        $('#successDlg').modal('show');
                    });
                    break;
            }
        });
    });
}

const initMemberDlg = () => {

    $('#memberDlg').on('show.bs.modal', async (e) => {

        document.getElementById("loader").style.display = "block";

        const key = e.relatedTarget.dataset.key,
            member = members.find(x => x.id === parseInt(key, 10));

        $('#memberDlgLbl').text('Viewing ' + member.name + '... ');

        let content = '<tr><td>' +
            getLabel({ content: 'Email', attrs: { cssClass: 'w100' } }) +
            getSpan({ content: member.email }) +
            '</td></tr><td>' +
            getLabel({ content: 'Phone', attrs: { cssClass: 'w100' } }) +
            getSpan({ content: member.phone }) +
            '</td></tr>';

        const [profileQuestionsData, profileResponsesData] =
            await allSettled({
                promises: [
                    getMemberProfileQuestionsAsync(),
                    getMemberProfileResponsesAsync({ mg: member.mg })
                ]
            });

        if (profileQuestionsData.status === 'rejected') {
            clearMySNError();
            content +=
                '<tr><td>' +
                getSpan({ content: 'Member has not entered any profile information on their phone.' }) +
                '</td></tr>';
        } else if (profileResponsesData.status === 'rejected') {
            clearMySNError();
            content += '<tr><td>' +
                getSpan({ content: 'Member has not entered any profile information on their phone.' }) +
                '</td></tr>';
        } else {

            const profileResponses = profileResponsesData.value;

            if (profileResponses.hasOwnProperty('address')) {
                const address = profileResponses.address;
                const hasAdr1 = address.adr1 != '';
                const hasAdr2 = address.adr2 != '';
                const hasCSZ = address.city != '' || address.st != '' || address.zip != '';
                if (hasAdr1 || hasAdr2 || hasCSZ) {
                    content += '<tr><td><table><tr><td>' + getLabel({ content: 'Address', attrs: { cssClass: 'w100' } }) + '</td>';
                    if (hasAdr1) {
                        content += `<td class="w200">${address.adr1}</td></tr>`;
                    }
                    if (hasAdr2) {
                        content += hasAdr1
                            ? `<tr><td></td><td class="w200">${address.adr2}</td></tr>`
                            : `<td class="w200">${address.adr2}</td></tr>`;
                    }
                    if (hasCSZ) {
                        content += '<tr><td></td><td class="w200">' +
                            (address.city !== '' ? address.city + ', ' : '') +
                            (address.st !== '' ? address.st + ' ' : '') +
                            (address.zip !== '' ? address.zip : '') +
                            '</td></tr>';
                    }
                    content += '</table></tr></td>';
                }
            }
            if (profileResponses.hasOwnProperty('children') && profileResponses.children.length > 0) {
                const children = profileResponses.children;
                content += '<tr><td><table><tr><td>' + getLabel({ content: 'Children', attrs: { cssClass: 'w100' } }) +
                    '</td><td class="w200"></td><td>' +
                    getLabel({ content: 'Birthday', attrs: { cssClass: 'w100' } }) + '</td>';
                children.forEach((child) => {
                    const birthday = (child.bDay !== undefined && child.bDay !== null && child.bDay !== '')
                        ? formatAsShortDate(new Date(child.bDay))
                        : '';
                    content += `<tr><td></td><td class="w200">${child.fNm} ${child.lNm}</td><td class="w100">${birthday}</td></tr>`;
                });
                content += '</table></tr></td>';
            }
            if (profileResponses.hasOwnProperty('job') && profileResponses.job != '') {
                content += '<tr><td>' + getLabel({ content: 'Occupation', attrs: { cssClass: 'w100' } }) +
                    getSpan({ content: profileResponses.job }) + '</td></tr>';

            }
            if (profileResponses.hasOwnProperty('bDay') && profileResponses.bDay != '') {
                const birthday = (profileResponses.bDay !== undefined && profileResponses.bDay !== null && profileResponses.bDay !== '')
                    ? formatAsShortDate(new Date(profileResponses.bDay))
                    : '';
                content += '<tr><td>' + getLabel({ content: 'Birthday', attrs: { cssClass: 'w100' } }) +
                    getSpan({ content: birthday }) + '</td></tr>';

            }
            if (profileResponses.hasOwnProperty('cData') && profileResponses.cData.length > 0) {

                const profileQuestions = profileQuestionsData.value.cData;

                /* Some items saved to Cosmos db in cData have been deprecated we filter them out here */

                const parentRecs = profileQuestions.filter(row =>
                    row.pid === 0 &&
                    row.qType !== 1 && // 1=Phone deprecated - kept as part of sql server not Cosmos db
                    row.qType !== 2 && // saved as address property in Cosmos db
                    row.qType !== 3 && // saved as children property in Cosmos db
                    row.qType !== 6 && // saved as bDay property in Cosmos db
                    row.qType !== 7); // saved as job property in Cosmos db

                const responses = profileResponses.cData;

                parentRecs.forEach(question => {

                    content += '<tr><td>';

                    if (question.cType === 0 && question.childType === 0) { /* Text */

                        content += getSpan({ content: question.text });

                    }
                    else if ((question.cType === 1 || question.cType == 2) && question.childType === 0) { /* Fill In The Blank or Memo */

                        content +=
                            getDiv({ content: getLabel({ content: question.text }) });

                        const response = responses.find(x => x.id === question.id);
                        if (response) {
                            content += getDiv({ content: response.value });
                        }
                    }
                    else if (question.cType === 0 && (question.childType === 3 || question.childType === 4)) { /* CheckBox or Radio Button*/

                        content += getDiv({ content: getLabel({ content: question.text }) });

                        const options = profileQuestions.filter(x => x.pid === question.id);

                        options.forEach(option => {

                            if (option.cType === 0) { /* Vertical text separating Checkbox or Radio options */
                                content += getDiv({
                                    content: option.text,
                                    attrs: option.iL === 0 /* Indent Level */
                                        ? {}
                                        : {
                                            cssClass: option.iL === 1
                                                ? 'indent1'
                                                : 'indent2'
                                        }
                                });
                            }
                            else if (option.cType === 3 || option.cType === 4) { /* CheckBox or Radio Button */

                                const response = responses.find(x => parseInt(x.id, 10) === option.id);
                                const hasResponse = response !== undefined && response.bValue !== undefined;

                                let isCheckedSymbol = 'fa fa-square-o'; // Default unchecked symbol'
                                if (option.cType === 3) { // CheckBox
                                    if (hasResponse) {
                                        isCheckedSymbol = response.bValue === true
                                            ? 'fa fa-check-square-o' // Checked symbol
                                            : 'fa fa-square-o'; // Unchecked symbol
                                    }
                                    else {
                                        isCheckedSymbol = 'fa fa-square-o'; // Default unchecked symbol
                                    }
                                }
                                else if (option.cType === 4) { // Radio Button
                                    if (hasResponse) {
                                        isCheckedSymbol = response.bValue === true
                                            ? 'fa fa-dot-circle-o' // Checked symbol
                                            : 'fa fa-circle-o'; // Unchecked symbol
                                    } else {
                                        isCheckedSymbol = 'fa fa-circle-o'; // Default unchecked symbol
                                    }
                                }

                                let addedText = '';
                                if (option.hasTB === true) {
                                    addedText = hasResponse
                                        ? response.value
                                        : ' '.repeat(20); // Placeholder for text input
                                }

                                const choice = getSpan({ content: ' ', attrs: { cssClass: isCheckedSymbol } }) +
                                    getSpan({ content: option.text, attrs: { cssClass: 'mLeft10' } }) +
                                    getSpan({ content: addedText, attrs: { cssClass: 'snU' } });

                                content += getDiv({ content: choice });
                            }
                        });

                    }

                    content += '</td></tr>';
                });
            };

        }
        $('#gridMemberProfile > tbody').empty().append(content);

    });
}

/* public functions */

let members = [];

const initAsync = async () => {
    setMenu();

    try {
        members = await getMembersDataAsync()
        getTableRows({ arr: members, fnGetRow: getDirectoryRow, gridNm: 'gridDirectory' });
        initConfirmDlg();
        initMemberDlg();
    }
    catch (error) { }
};

window.snChurchDirectory = {
    initAsync
};